module.exports = __webpack_public_path__ + "img/tijian.0d60609.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tijian.png
// module id = C5Z1
// module chunks = 0